import { createFileRoute, Outlet } from '@tanstack/react-router';

import { NavPanel } from '@components/dashboard';
import { requireActiveSession } from '@helpers/sessionGuard.helper';

export const Route = createFileRoute('/_dashboard')({
  beforeLoad: ({ context, location }) =>
    requireActiveSession({
      isAuthenticated: context.auth.isAuthenticated,
      queryClient: context.queryClient,
      redirectTo: location.href,
    }),
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <div
      className="bg-background text-text min-h-dvh px-4 py-5 sm:px-6 lg:px-8"
      data-slot="app-shell"
    >
      <div className="mx-auto grid w-full max-w-7xl gap-5 md:grid-cols-[240px_minmax(0,1fr)]">
        <NavPanel />

        <main className="bg-surface shadow-raised min-h-[calc(100dvh-40px)] w-full rounded-[22px] p-6 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
